import { createSlice } from '@reduxjs/toolkit';


const initialState = null;

const slice = createSlice({
  name: 'reLock',
  initialState,
  reducers: {
    triggerReLock: (_, action) => action.payload,
    clearReLockData: () => null,
  },
});

export const {
  triggerReLock,
  clearReLockData,
} = slice.actions;

export default slice;
